import barbara2 from "./../assets/barbara2.jpg";

export default function SobreMi() {
  return (
    <section className="bg-white overflow-hidden" id="sobremi">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-lighter text-primary font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3">
            Conóceme
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Sobre Mí
          </h2>
        </div>

        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-start">

          {/* Image col */}
          <div className="relative mb-12 lg:mb-0 flex justify-center">
            {/* Decorative bg */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary-lighter to-ocean-lighter rounded-4xl transform -rotate-3 scale-95 opacity-60" />
            <div className="relative rounded-4xl overflow-hidden shadow-soft-lg border-4 border-white max-w-md w-full">
              <img
                className="w-full object-cover object-center"
                src={barbara2}
                alt="Barbara Zamora Tapia"
              />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-soft-lg px-6 py-3 flex items-center gap-3 whitespace-nowrap">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-light rounded-xl flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div>
                <p className="font-heading font-semibold text-gray-800 text-sm">U. de los Andes</p>
                <p className="text-xs text-gray-500 font-body">Egresada 2019 · Mención Pediatría</p>
              </div>
            </div>
          </div>

          {/* Text col */}
          <div className="space-y-5 pt-4">
            <p className="text-gray-700 font-body text-lg leading-relaxed">
              Hola, mi nombre es <span className="font-semibold text-primary">Barbara Zamora</span>, soy Terapeuta Ocupacional con
              mención en Pediatría, egresada de la Universidad de los Andes
              (2019), diplomada en Educación Inclusiva y certificada como
              tutor sombra.
            </p>

            <p className="text-gray-600 font-body text-base leading-relaxed">
              Mi experiencia data desde el 2019 en la atención a niños de los
              0 a 12 años en el área de salud privada a través de atenciones
              domiciliarias dentro de la Región Metropolitana, en colegio
              internacional, en diversos Centros especializados en primera
              infancia, abordando Trastornos del Espectro Autista, Trastornos
              del Neurodesarrollo, Trastornos de la Conducta infantil –
              juvenil y Trastornos en el procesamiento sensorial.
            </p>

            <p className="text-gray-600 font-body text-base leading-relaxed">
              Así como soy Terapeuta Ocupacional, soy nadadora de Natación
              Clásica. A los 3 años aprendí a nadar y a los 10 años tomé la
              decisión de ser parte de un equipo y empecé a competir en
              diferentes campeonatos a lo largo del país. También tuve la
              oportunidad de vivir en Alemania y formar parte de otro equipo.
              En la Universidad fui parte de la selección de natación y seguí
              compitiendo representando a mi Universidad en campeonatos nacionales.
            </p>

            <p className="text-gray-600 font-body text-base leading-relaxed">
              Gracias a la natación he podido adquirir herramientas que me han
              ayudado a mi crecimiento personal y profesional, convirtiéndome
              en profesora de natación certificada por la Asociación Americana
              de Coaches de Natación, <span className="font-semibold text-ocean">SwimAmerica Program</span>.
            </p>

            <p className="text-gray-600 font-body text-base leading-relaxed">
              Mi carrera me ha permitido ocupar mis hobbies e intereses en el
              trabajo con los niños pudiendo entregarles herramientas que les
              permitirán experimentar y conocer desde pequeños su mundo,
              crecer y desenvolverse de la mejor manera.
            </p>

            {/* Skill chips */}
            <div className="flex flex-wrap gap-2 pt-2">
              {["TEA", "Neurodesarrollo", "Procesamiento Sensorial", "Educación Inclusiva", "Tutor Sombra", "Natación Clásica", "Aquafitness"].map((skill) => (
                <span key={skill} className="bg-primary-lighter text-primary font-body font-semibold text-sm px-4 py-1.5 rounded-full border border-primary/20">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Wave transition */}
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" fill="#EEF2FF" />
        </svg>
      </div>
    </section>
  );
}
